const catIds = (inst) => [
  ...(inst?.categories || []).map((c) => c.id),
  inst?.category?.id,
].filter(Boolean);

/** Other published tests, same-category ones first, keeping catalogue order. */
export function pickNextTests(instruments, currentSlug, limit = 3) {
  const list = Array.isArray(instruments) ? instruments : [];
  const current = list.find((i) => i.slug === currentSlug);
  const mine = new Set(catIds(current));
  const others = list.filter((i) => i.slug && i.slug !== currentSlug);
  const related = others.filter((i) => catIds(i).some((c) => mine.has(c)));
  const rest = others.filter((i) => !related.includes(i));
  return [...related, ...rest].slice(0, limit);
}
